import { InterventionStep as InterventionStepType } from "src/types/interventions";
import { StepType } from "../../../types";
import { LimbicMessage } from "../Chat";

type InterventionStepProps = {
  step: InterventionStepType;
  opaque?: boolean;
  selected?: boolean;
};

export const InterventionStep = ({ step, opaque }: InterventionStepProps) => {
  if (step.type === StepType.informational) {
    return <LimbicMessage key={step.id} step={step!} />;
  }

  return (
    <div key={step.id}>
      <LimbicMessage opaque={opaque} step={step!} />
    </div>
  );
};
